"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExpandableSection = exports.default = exports.EnhancedExpandableContainer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 0;\n  border-top: solid 1px #E4E4E4;\n  position: relative;\n  margin: 20px 0;\n\n  svg {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translateX(-50%) translateY(-50%);\n    cursor: pointer;\n  }\n"], ["\n  width: 100%;\n  height: 0;\n  border-top: solid 1px #E4E4E4;\n  position: relative;\n  margin: 20px 0;\n\n  svg {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translateX(-50%) translateY(-50%);\n    cursor: pointer;\n  }\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n"], ["\n  width: 100%;\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ExpandIcon = require("./ExpandIcon");

var _ExpandIcon2 = _interopRequireDefault(_ExpandIcon);

var _CollapseIcon = require("./CollapseIcon");

var _CollapseIcon2 = _interopRequireDefault(_CollapseIcon);

var _ExpandableSection = require("./components/ExpandableSection");

var _ExpandableSection2 = _interopRequireDefault(_ExpandableSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledDivider = _styledComponents2.default.div.withConfig({
  displayName: "src__StyledDivider",
  componentId: "sc-1uziej7-0"
})(_templateObject);

var StyledWrapper = _styledComponents2.default.div.withConfig({
  displayName: "src__StyledWrapper",
  componentId: "sc-1uziej7-1"
})(_templateObject2);

var Divider = function Divider(_ref) {
  var onClick = _ref.onClick,
      expanded = _ref.expanded;
  return _react2.default.createElement(
    StyledDivider,
    null,
    expanded ? _react2.default.createElement(_CollapseIcon2.default, { onClick: onClick }) : _react2.default.createElement(_ExpandIcon2.default, { onClick: onClick })
  );
};

var ExpandableContainer = function ExpandableContainer(_ref2) {
  var mainContent = _ref2.mainContent,
      expandedContent = _ref2.expandedContent,
      onToggle = _ref2.onToggle,
      expanded = _ref2.expanded,
      dividerComponent = _ref2.dividerComponent,
      showBottom = _ref2.showBottom,
      bottomToggleComponent = _ref2.bottomToggleComponent;

  var Divider = dividerComponent;
  var BottomToggle = bottomToggleComponent;
  return _react2.default.createElement(
    StyledWrapper,
    null,
    mainContent,
    _react2.default.createElement(Divider, { onClick: onToggle, expanded: expanded }),
    expanded && expandedContent,
    expanded && showBottom && _react2.default.createElement(BottomToggle, { onClick: onToggle, expanded: expanded })
  );
};

ExpandableContainer.propTypes = {
  mainContent: _propTypes2.default.element.isRequired,
  expandedContent: _propTypes2.default.element.isRequired,
  onToggle: _propTypes2.default.func.isRequired,
  expanded: _propTypes2.default.bool.isRequired,
  dividerComponent: _propTypes2.default.func,
  showBottom: _propTypes2.default.bool,
  bottomToggleComponent: _propTypes2.default.func
};

ExpandableContainer.defaultProps = {
  dividerComponent: Divider,
  showBottom: false,
  bottomToggleComponent: Divider
};

var EnhancedExpandableContainer = exports.EnhancedExpandableContainer = function (_Component) {
  _inherits(EnhancedExpandableContainer, _Component);

  function EnhancedExpandableContainer() {
    var _ref3;

    var _temp, _this, _ret;

    _classCallCheck(this, EnhancedExpandableContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = EnhancedExpandableContainer.__proto__ || Object.getPrototypeOf(EnhancedExpandableContainer)).call.apply(_ref3, [this].concat(args))), _this), _this.state = { expanded: false }, _this.toggle = function () {
      _this.setState({
        expanded: !_this.state.expanded
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EnhancedExpandableContainer, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          mainContent = _props.mainContent,
          expandedContent = _props.expandedContent,
          dividerComponent = _props.dividerComponent,
          showBottom = _props.showBottom,
          bottomToggleComponent = _props.bottomToggleComponent;


      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(ExpandableContainer, {
          mainContent: mainContent,
          expandedContent: expandedContent,
          onToggle: this.toggle,
          expanded: this.state.expanded,
          dividerComponent: dividerComponent,
          showBottom: showBottom,
          bottomToggleComponent: bottomToggleComponent })
      );
    }
  }]);

  return EnhancedExpandableContainer;
}(_react.Component);

exports.default = ExpandableContainer;
exports.ExpandableSection = _ExpandableSection2.default;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-expandable-container/dist/index.js
// module id = 407
// module chunks = 168707334958949